import { createSelector } from 'reselect'
import first from 'lodash/first'
import get from 'lodash/get'

export const selectCustomSupporterPages = store => store.customSupporterPages.data
export const selectCustomSupporterPageStatus = store => store.customSupporterPages.status

export const selectCustomSupporterPage = createSelector(
  [ selectCustomSupporterPages ],
  customSupporterPages => first(customSupporterPages)
)

export const selectCustomSupporterPagePresent = createSelector(
  [ selectCustomSupporterPage ],
  customSupporterPage => ({ hasCustomSupporterPages: get(customSupporterPage, 'id', false) })
)
